import React from 'react';
import styles from './LockedPriceTag.module.scss';

/* Types */
import { PaidTipProduct, TipProduct } from '../../interfaces/TipProduct';

/* Assets */
import lockIcon from '../../../../../assets/icons/tips/lock.png';
import couponIcon from '../../../../PaymentGateway/assets/icons/coupon.png';

/* Providers */
import { useShopContext } from '../../../shared/__providers__/ShopContext';
import { useProductContext } from '../../../../PaymentGateway/__providers__/ProductContext';

/* Translations */
import { useTranslation } from 'react-i18next';
import { tr } from '../../../../../utils/translations/translator';

interface LockedPriceTagProps {}

export const LockedPriceTag: React.FC<LockedPriceTagProps> = () => {
  const { t } = useTranslation();
  const { shop } = useShopContext();
  const tip = shop!.selectedProduct as TipProduct;
  const { product } = useProductContext();
  const unlockable = product.unlockable;

  return (
    <>
      {tip && (
        <>
          <div className={styles.locked}>
            {unlockable ? (
              <div className={styles.messageContainer}>
                <span className={styles.mainText}>
                  {tr(t, 'unlock')}{' '}
                  <img
                    src={couponIcon}
                    alt="Coupon Icon"
                    className={styles.icon}
                  />
                </span>
              </div>
            ) : (
              <div className={styles.messageContainer}>
                <span className={styles.mainText}>
                  {(tip as PaidTipProduct).discountPercentage > 0
                    ? (tip as PaidTipProduct).priceWithDiscount
                        .buildPrice()
                        .toString()
                    : (tip as PaidTipProduct).price.buildPrice().toString()}
                </span>

                {(tip as PaidTipProduct).discountPercentage > 0 && (
                  <span className={styles.subText}>
                    <div className={styles.dash} />
                    {(tip as PaidTipProduct).price.buildPrice().toString()}
                  </span>
                )}
              </div>
            )}

            <img src={lockIcon} alt="Lock Icon" className={styles.lockIcon} />
          </div>
        </>
      )}
    </>
  );
};
